import React from 'react';

export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=net.etenant.app';

/** Four-color Google Play triangle, sized by the className's CSS. */
const GooglePlayLogo: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 512 512" aria-hidden="true">
    <path fill="#00c3ff" d="M74 44 L256 256 L74 468 C62 462 56 450 56 436 V76 C56 62 62 50 74 44 Z" />
    <path fill="#00e676" d="M74 44 C84 38 98 38 110 45 L340 177 L256 256 Z" />
    <path fill="#ffc400" d="M340 177 L432 230 C452 242 452 270 432 282 L340 335 L256 256 Z" />
    <path fill="#ff3a44" d="M256 256 L340 335 L110 467 C98 474 84 474 74 468 Z" />
  </svg>
);

export default GooglePlayLogo;
